import React, { useEffect, useRef } from 'react'
import * as queryString from 'query-string';
import { MapSection } from '../components/_pages/home/map-section';
import Landing from '../components/_pages/home/landing/HomeLanding';
import {LocationList} from '../components/_pages/home/location-list';
import { EmailCaptureSection } from '../components/general/email-capture';
import { LearnMoreSection } from '../components/_pages/home/learn-more-section';
import { MapVideoMobile } from '../components/_pages/home/map-section/subcomponents/map-video-overlay';
import { useStore } from '../hooks/useStore';
import { ShareCardSection } from '../components/_pages/home/share-card-section';

const HomeView = (props) => {
    const globalData = props.data.allContentfulGlobalSiteData.edges[0].node;
    const {uiStore: {openHomeLocationList, setActiveMapCity, setActiveLocationCity}} = useStore();
    const {city, showOrgs} = queryString.parse(props.location.search);
    const mapRef = useRef(null);

    useEffect(() => {
      if (city) {
        const capCity = city.length < 3 ? city.toUpperCase() : city.charAt(0).toUpperCase() + city.slice(1);
        setActiveMapCity(capCity);
        setActiveLocationCity(capCity);

        setTimeout(() => {
          mapRef.current?.scrollIntoView({behavior: 'smooth', block: 'start'});
          if (showOrgs === 'true') {
            openHomeLocationList();
          }
        }, 1350);
      }
    }, []);



    return (    
        <div>
            <Landing data={globalData}/>
            <div ref={mapRef} />
            <MapSection city={city} data={globalData} locationData={props.data}/>
            <LocationList data={props.data}/>
            <MapVideoMobile/>
            <ShareCardSection data={globalData} locationData={props.data}/>
            <EmailCaptureSection data={globalData}/>
            <LearnMoreSection data={globalData}/>


            <style jsx>{`
              div {
                overflow: hidden;
              }
            `}</style>
        </div>
  )
}

export default HomeView;